import {ServerConfig} from "@/config/config";
import {Axios} from "@/utils/axios";
import {Sale} from "@/models/base";
import {RecoverySale} from "@/models/base/recovery-sale";

export class RecoveryServiceClass{

	get url(): string {
		return ServerConfig.host + "/recovery-sales";
	}
	async get(id:number){
		let result = await Axios.get(`${this.url}/${id}`);
		return new RecoverySale(result.data);
	}
	async getBySaleID(id:number){
		let result = await Axios.get(`${this.url}/by-sale-id/${id}`);
		return new RecoverySale(result.data);
	}
	async deleteBySaleID(id:number){
		let result = await Axios.delete(`${this.url}/by-sale-id/${id}`);
		return new RecoverySale(result.data);
	}
	async put(id:number, sale:Sale): Promise<RecoverySale>{
		let result = await Axios.put(`${this.url}/${id}`,sale.getJSON());
		return new RecoverySale(result.data);
	}
	async post(sale:Sale): Promise<RecoverySale>{
		let result = await Axios.post(`${this.url}`,sale.getJSON());
		return new RecoverySale(result.data);
	}

}
export const RecoveryService = new RecoveryServiceClass();